<div
  [class]="'unity-card ' + convertColors()"
  [class.metric]="isMetric"
  style="margin-bottom: 15px"
  [style.border-left-color]="customColor ? customColor : ''"
>
  <div *ngIf="!isMetric" class="header">
    <div class="info" [class.header-wrapper]="allowCollapse || iconSecondary" (dblclick)="onDoubleClick()">
      <h3 *ngIf="title">
        <span class="title-wrapper">
          <span *ngIf="icon">
            <i *ngIf="!icon.includes('unity-icon')" [class]="icon"></i>
            <svg *ngIf="icon.includes('unity-icon')" [class]="'unity-icon ' + icon">
              <use attr.xlink:href="#{{ icon }}"></use>
            </svg>
          </span>
          <span>{{ title }}</span>
          <unity-badge *ngIf="count" class="muted {{ statusBadgeColor }}">{{ count }}</unity-badge>
        </span>
        <!-- <span class="icon-wrapper"> -->
          <svg
            *ngIf="iconSecondary"
            class="unity-icon {{ iconSecondary }}"
            style="margin-left: 0.25rem"
            [ngbTooltip]="iconSecondaryTooltip"
          >
            <use attr.xlink:href="#{{ iconSecondary }}"></use>
          </svg>
          <button unity-button
            *ngIf="allowCollapse"
            class="icon-only"
            (click)="onDoubleClick()"
            [ngbTooltip]="collapsed ? 'Expand Section' : 'Collapse Section'"
          >
            @if (collapsed) {
                <unity-icon icon="chevron-down"/>
            } @else {
                <unity-icon icon="chevron-up"/>
            }
          </button>
        <!-- </span> -->
      </h3>

      <div *ngIf="desc" class="description">{{ desc }}</div>
    </div>
  </div>
  <div class="body">
    <ng-container *ngIf="isMetric; else other_content">
      <div *ngIf="icon" class="icon magenta">
        <svg *ngIf="icon.includes('unity-icon'); else otherIcon" [class]="'unity-icon ' + icon">
          <use attr.xlink:href="#{{ icon }}"></use>
        </svg>
        <ng-template #otherIcon>
          <i
            class="fa {{ icon }}"
            style="width: 3rem; height: 3rem; color: var(--unity-color-icon-secondary-on_light); font-size: 3rem"
          ></i>
        </ng-template>
      </div>
      <div class="info">
        <div *ngIf="label" class="label">
          {{ label }}
        </div>
        <h3 *ngIf="stat" class="stat">{{ stat }}</h3>
        <div class="description">
          {{ desc || subtitle || '&nbsp;' }}
          <div
            *ngIf="progress"
            class="ep-progressbar-frame"
            style="height: 5px; width: 100%; margin-top: 2px; background-color: #cdcaca"
          >
            <div class="ep-progressbar" [style.width.%]="progress" style="height: 100%"></div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #other_content><ng-content></ng-content></ng-template>
  </div>
</div>
